import { toast } from "sonner";
import { formatPickupWindowLabel } from "./formatPickupWindowLabel";

const recent = new Map();

/** One visible notice when the restaurant proposes a new pickup time. */
export function notifyCustomerBulkProposal(detail = {}) {
  const orderId = String(detail.orderId || "").trim();
  const proposed = String(detail.proposedPickupWindow || "").trim();
  const body = String(detail.body || "").trim();
  if (!orderId || (!proposed && !body)) return;
  if (detail.bulkConfirmationStatus && detail.bulkConfirmationStatus !== "owner_proposed") return;

  const key = `${orderId}|${proposed || body}`;
  const now = Date.now();
  if (now - (recent.get(key) || 0) < 20000) return;
  recent.set(key, now);

  const windowLabel = proposed ? formatPickupWindowLabel(proposed) : "";
  const shop = String(detail.restaurantName || "Le restaurant").trim() || "Le restaurant";
  toast.message(detail.title || "Nouvelle heure proposée", {
    description: body || `${shop} propose ${windowLabel} pour votre commande.`,
    duration: 12000,
  });
}
